<template>
  <div class="modal modal-timeout" :class="{'is-active' : modalIsOpen}">
  <!--   Session timeout modal-->
  <!--    onclick call the show_timeout_modal to prevent default modal behaviour where it closes modal when the background is clicked-->
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="box content session-timeout-modal__box has-text-centered">
        <img class="session-timeout-modal__icon" src="/assets/images/2021/session-timeout/timeout.svg">
        <h2>{{ modal.title }}</h2>
        <p class="text is-size-6-tablet has-text-centered">You weren't clicking around any more, so we need you to re-enter your information. </p>
        <p class="text is-size-6-tablet has-text-centered">To get back in, start again from our homepage</p>
        <button class="button is-cta" v-on:click="redirect()">{{ modal.buttonLabel}}</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  mounted: function () {
    // Run once completely rendered.
    this.$nextTick( () => {
      this.processStart = Date.now();
      this.startTimeoutTimer();
    })
  },
  components: {
  },
  watch: {
    $route (to, from) {
      if (to.name !== from.name) {
        this.restartTimeoutTimer();
      }
    }
  },
  metaInfo () {
    console.log('run on page change');
  },
  methods: {
    startTimeoutTimer: function() {
        this.start = Date.now();
        this.timeout = setTimeout(() => {
        this.end = Date.now();
        this.showTimeoutModal();
        clearTimeout(this.timeout);
      }, this.interval_delay);
    },
    restartTimeoutTimer: function() {
      clearTimeout(this.timeout);
      this.startTimeoutTimer();
    },
    showTimeoutModal: function (event) {
        try {

          this.seconds = (Math.floor((this.end - this.start) / 1000));
          if (this.$store.getters.client.cli_num) {
            this.modal.buttonRedirectUrl = "/app/login?redirect=/spa/vehicle/new";
          }
          this.gtagData.event_type = 'Session timeout';
          this.gtagData.policy_form_type = 'Vehicle';
          this.gtagData.policy_form_start_time = new Date(this.processStart).toLocaleString('sv');
          this.gtagData.page_start_time = new Date(this.start).toLocaleString('sv');
          this.gtagData.page_end_time = new Date(this.end).toLocaleString('sv');
          this.gtagData.session_timeout_seconds = this.seconds;
          this.gtagData.page_path = String(window.location.origin + this.$route.path);

          // gtag should be loaded by now.
          window.gtag('event', 'form_session_timeout', this.gtagData);
        } catch {
          console.error('err notifying google analytics on session timeout modal')
        }
        this.modalIsOpen = true;
    },
    redirect: function() {
      try {
        this.redirectTime = Date.now();
        this.gtagData.event_type = 'Start again';
        this.gtagData.redirect_time = new Date(this.redirectTime).toLocaleString('sv');
        this.gtagData.idle_seconds = (Math.floor((Date.now() - this.start) / 1000))
        // New GA4.
        window.gtag('event', 'form_session_timeout', this.gtagData);
        window.location.replace(this.modal.buttonRedirectUrl);
      } catch (e) {
        console.log(e);
      }

    }
  },
  computed: {
  },
  data () {
    return {
      modal: {
        title: 'Session timeout',
        buttonLabel: 'Start again',
        buttonRedirectUrl: '/spa/vehicle/new',
      },
      modalIsOpen: false,
      timeout: null,
      seconds: 0,
      processStart: Date.now(),
      start: Date.now(),
      end: 0,
      redirectTime: 0,
      interval_delay: 3600000, // 1 hour in milliseconds.
      gtagData: {
        event_type: '',
        event_desc: '',
        policy_form_type: '',
        policy_form_start_time: '',
        page_start_time: '',
        page_end_time: '',
        session_timeout_seconds: 0,
        page_path: ''
      }
    }
  },
  name: 'session-timeout-modal'
}

</script>

<style scoped lang="scss">
  .modal-timeout {
    z-index:100;
  }
</style>